const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/fiscalization.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/fiscalization")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});